
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'CheckBox',
  inheritAttrs: false,
  props: {
    modelValue: null,
    label: String,
    value: null,
    inline: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const internalValue = computed({
      get: () => props.modelValue,
      set: (v) => emit('update:modelValue', v),
    });

    return {
      internalValue,
    };
  },
});
